export var getDescriptionItem = function getDescriptionItem(itemNumber, itemText) {
  return !!itemNumber && !!itemText ? " \xB7 ".concat(itemNumber, " ").concat(itemText) : '';
};